import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';
import { NewsItem } from '../../types/News';

export const newsApi = createApi({
  reducerPath: 'newsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: cmsApiConfig.url,
    headers: {
      'X-CSRF': '1',
    },
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    getNews: builder.query<NewsItem[], void>({
      query: () => ({
        url: `/news/getNewsItems`,
      }),
    }),
    getLatestNews: builder.query<NewsItem, void>({
      query: () => ({
        url: `/news/getLatestNews`,
      }),
    }),
  }),
});

export const { useLazyGetNewsQuery, useLazyGetLatestNewsQuery } = newsApi;
